import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LabRequisitionStatus } from 'src/app/enum/water-lab/LabRequisitionStatus';
import { AccessUserInfo, UserDetail } from 'src/app/models';
import { FirstPrintLabelDateResponse, ShippingManifestData, Time } from 'src/app/models/water-lab/shipping-manifest';
import { LabRequisitionService, MessageService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';
import { WorkFlow } from "src/app/enum/water-lab/workFlow"
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { CustomDatePipe } from 'src/app/pipes';
import { SelectItem } from 'primeng';
@Component({
  selector: 'bart-enter-draw-date',
  templateUrl: './enter-draw-date.component.html',
  styleUrls: ['./enter-draw-date.component.scss'],
  providers: [DatePipe, CustomDatePipe]
})
export class EnterDrawDateComponent implements OnInit {
  cols: any[];
  isEdit: boolean = false;
  hours: SelectItem[];
  minutes: SelectItem[];
  drawDate: Date = new Date()
  min: Date;
  max: Date;
  manifestData: ShippingManifestData[];
  public userInfo: UserDetail;
  selectedMinutes: string = "00"
  selectedHour: string = "00"
  public ENUM_WORKFLOW = WorkFlow;
  validPMList: ShippingManifestData[] = [];
  errorPMList: ShippingManifestData[] = []
  isShowErrorInfoIcon = false;
  headerText: string = "Enter Draw Date"
  shipmentReceivedDateLocalFormat: Date | null;
  workFlow: string;
  firstPrintLabelDateResponse: FirstPrintLabelDateResponse[];
  constructor
    (
      private _dynamicDailogConfig: DynamicDialogConfig,
      private _requisitionService: LabRequisitionService,
      private _datePipe: DatePipe,
      private _dynamicDialogRef: DynamicDialogRef,
      private _loaderService: LoaderService,
      private _userService: UserService,
      private customDatePipe: CustomDatePipe,
      private _messageService: MessageService
    ) { }

  ngOnInit() {

    this.cols =
      [
        { field: 'TestDisplayName', header: 'Test ID | Name', display: 'table-cell', width: "35%" },
        { field: 'LabRequisitionNumber', header: 'Requisition ID', display: 'table-cell', width: "20%" },
        { field: 'ContainerDisplayName', header: 'Container ID | Description', display: 'table-cell', width: "35%" },
      ];
    this.userInfo = AccessUserInfo.getUserInfo();
    if (this._dynamicDailogConfig) {
      this.isEdit = this._dynamicDailogConfig.data.isEdit;
      this.manifestData = this._dynamicDailogConfig.data.data;
      this.workFlow = this._dynamicDailogConfig.data.workFlow;
      // Fetching first print label date as this is pre-requisite for the rest of the operations.
      this.getFirstPrintLabelDate();
    }
  }

  configureTime() {
    this.hours = [];
    this.minutes = [];
    for (let i = 0; i <= 23; i++) {
      let j = 0;
      if (i <= 9) {
        this.hours.push({ label: j + i.toString(), value: j + i.toString() });
      }
      else { this.hours.push({ label: i.toString(), value: i.toString() }); }
    }
    for (let x = 0; x <= 59; x++) {
      let y = 0;
      if (x <= 9) {
        this.minutes.push({ label: y + x.toString(), value: y + x.toString() });
      }
      else { this.minutes.push({ label: x.toString(), value: x.toString() }); }
    }
  }

  loadData() {

    //Start:PCR-007.1: Lab NEW Requirement - Lab New Profile Code 0386 [FREQ-774268]
    this.manifestData.forEach(itm => {
      itm.ContainerDisplayName = "";
      if (itm.LabContainerID.indexOf('|') > 1) {
        itm.LabContainerID.split('|').forEach((x, index) => {
          itm.ContainerDisplayName = itm.ContainerDisplayName + (index > 0 ? "; " + x.trim() : "" + x.trim()) + " | " + itm.ContainerDescription.split('|')[index].trim()
        })

      }
      else {
        itm.ContainerDisplayName = itm.LabContainerID + " | " + itm.ContainerDescription;
      }
    })
    //End:PCR-007.1: Lab NEW Requirement - Lab New Profile Code 0386 [FREQ-774268]

    if (this.isEdit) {
      this.headerText = "Edit Draw Date"
      if (this.manifestData[0].DrawDate != null) {
        this.drawDate = new Date(this.manifestData[0].DrawDate);
        let actiualDrawDate = this.manifestData[0].DrawDate.split(" ");
        let drawTime = actiualDrawDate[1].split(":")
        this.selectedHour = drawTime[0];
        this.selectedMinutes = drawTime[1];
      }
      //Start:Added on 20-Oct-2023 for PCR013
      if (this.ENUM_WORKFLOW.HOME == this.workFlow && this.manifestData[0].ShipmentReceivedDate) {
        this.shipmentReceivedDateLocalFormat = new Date(this.customDatePipe.transform(this.manifestData[0].ShipmentReceivedDate, "local", "MM/dd/yyyy HH:mm"));
      }
      //End:Added on 20-Oct-2023 for PCR013
      //Start:Added on 20-Oct-2023 for PCR016//Set print Label date as default draw date if anticipated draw date not in range of print label date and recieved date
      let tempshipmentReceivedDateLocalFormat = this.shipmentReceivedDateLocalFormat ? this.shipmentReceivedDateLocalFormat : new Date();
      if (this.drawDate < new Date(this.manifestData[0].PrintLabelDate) || this.drawDate > tempshipmentReceivedDateLocalFormat) {
        this.drawDate = new Date(this.manifestData[0].PrintLabelDate);
        this.selectedHour = this.drawDate.getHours().toString();
        this.selectedMinutes = this.drawDate.getMinutes().toString();
      }
      //End:Added on 20-Oct-2023 for PCR016
    }
    else {
      this.setDefaultDrawDateTime();
    }

  }

  getFirstPrintLabelDate() {
    let getPrintLabelDateParams =
    {
      GetPrintLabelDate:
      {
        LabRequisitionID: this.manifestData.map(item => item.LabRequisitionID).join()
      }
    };
    this._requisitionService.getPrintLabelDate(JSON.stringify(getPrintLabelDateParams))
      .subscribe((resp: any) => {
        this.firstPrintLabelDateResponse = resp.getPrintLabelDate;
        if (this.firstPrintLabelDateResponse) {
          this.firstPrintLabelDateResponse.forEach(item => {
            //Convert date to local format
            item.FirstPrintLabelDate = this.customDatePipe.transform(item.FirstPrintLabelDate, "local", "MM/dd/yyyy HH:mm");
          });
          //Now that first print label date is received, proceed with loading data for edit draw date popup
          this.loadData();
          this.configureTime();
          this.setMin_MaxDrawDateTime();
        }
      },
        (error) => {
          console.log('error in getFirstPrintLabelDate ' + error);
        });
  }
  /*......................EnterDrawDate API................................*/
  updateDrawDate() {
    this.getShipmentReceivedDate(() =>   // Validate with Shipment Received Date-PCR013
    {
      this.setMin_MaxDrawDateTime();
      this.validPMList = [];
      this.errorPMList = [];
      this.isShowErrorInfoIcon = false;
      let drawDateTimeTemp = new Date(this.drawDate).setHours(Number(this.selectedHour), Number(this.selectedMinutes), 0, 0);
      this.manifestData.forEach((item) => {
        // JIRA-157/117- Consider first print label date instead of latest print label date
        let firstPrintValue = this.firstPrintLabelDateResponse.find(x => x.LabRequisitionID === item.LabRequisitionID).FirstPrintLabelDate;
        let firstPrintDate = new Date(firstPrintValue).setHours(new Date(firstPrintValue).getHours(), new Date(firstPrintValue).getMinutes(), 0, 0);
        let maxCalendarDateTimeTemp = new Date(this.max).setHours(this.max.getHours(), this.max.getMinutes(), 0, 0);
        if (drawDateTimeTemp < firstPrintDate || drawDateTimeTemp > maxCalendarDateTimeTemp) {
          this.errorPMList.push(item);
        }
        else {
          this.validPMList.push(item);
        }
      });

      if (this.validPMList.length) {
        this._loaderService.show()
        let utcDrawDate = this.customDatePipe.transform(this.drawDate.setHours(Number(this.selectedHour), Number(this.selectedMinutes), 0, 0), "UTC");;
        let drawDateParams =
        {
          UPDATEREQUISITIONDRAWDATE:
          {
            UserName: this.userInfo.userName,
            LabRequisitionID: this.validPMList.map(item => item.LabRequisitionID).join(),
            DrawDate: utcDrawDate,//this._datePipe.transform(this.drawDate,"MM/dd/yyyy")+" "+`${this.selectedHour}:${this.selectedMinutes}`,
            ActualDrawDateFlag: true,// PCR-016 (this.ENUM_WORKFLOW.HOME==this.workFlow && this.isActualDrawDate) ||this.ENUM_WORKFLOW.HOME!==this.workFlow?true:false,
            LabRequisitionStatusID: this.ENUM_WORKFLOW.HOME == this.workFlow ? LabRequisitionStatus.Shipped : LabRequisitionStatus.Pending
          }
        }
        this._requisitionService.updateDrawDate(drawDateParams).subscribe((response) => {
          this.validPMList.forEach((item) => {
            item.DrawDate = this.customDatePipe.transform(response.result[0].DrawDate, "local", "MM/dd/yyyy HH:mm"); //response.result[0].DrawDate
            item.DrawDateSort = new Date(this.customDatePipe.transform(response.result[0].DrawDate, "local", "MM/dd/yyyy HH:mm"))
          });
          this.manifestData = this.manifestData.filter((objFromA) => {
            return !this.validPMList.find((objFromB) => {
              return objFromA.LabRequisitionID === objFromB.LabRequisitionID
            })
          })
          this._loaderService.hide()

          if (this.ENUM_WORKFLOW.HOME == this.workFlow) {
            this._dynamicDialogRef.close({ refresh: true });
          }
          else if (this.errorPMList.length == 0) {
            this._dynamicDialogRef.close(this.manifestData);
          }
          this.isShowErrorInfoIcon = true;
        },
          (error) => {
            this._loaderService.hide()
            console.log(error);
          })
      }
      else {
        this.isShowErrorInfoIcon = true;
      }
      //#region User Action Audit
      var scrName = this.isEdit ? ScreenName.EDIT_DRAW_DATE : ScreenName.ENTER_DRAW_DATE;
      var userActionDescription = this.isEdit ? UserActionDescription.SHIPPING_MANIFEST_PENDING_EDIT_DRAW_DATE_POPUP_SAVE_CLICKED : UserActionDescription.SHIPPING_MANIFEST_PENDING_ENTER_DRAW_DATE_POPUP_SAVE_CLICKED;
      this._userService.logUserAction({
        userName: this.userInfo.userName,
        userAction: UserAction.BUTTON_CLICKED,
        screenName: scrName,
        screenPath: location.pathname,
        key: "LabRequisitionID",
        value: this.manifestData.map(x => x.LabRequisitionID).join(","),
        eventDescription: userActionDescription
      });
      //#endregion
    });
  }
  /*........................................ ................................*/
  /*.....................Delete Record.......................................*/
  deleteRecord(rowItem) {
    this.manifestData = this.manifestData.filter(x => x.LabRequisitionID != rowItem.LabRequisitionID);
    this.setMin_MaxDrawDateTime();
  }
  closePopup() {
    this._dynamicDialogRef.close()
    //#region User Action Audit
    var scrName = this.isEdit ? ScreenName.EDIT_DRAW_DATE : ScreenName.ENTER_DRAW_DATE;
    var userActionDescription = this.isEdit ? UserActionDescription.SHIPPING_MANIFEST_PENDING_EDIT_DRAW_DATE_POPUP_CANCEL_CLICKED : UserActionDescription.SHIPPING_MANIFEST_PENDING_ENTER_DRAW_DATE_POPUP_CANCEL_CLICKED;
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: scrName,
      screenPath: location.pathname,
      key: "LabRequisitionID",
      value: this.manifestData.map(x => x.LabRequisitionID).join(","),
      eventDescription: userActionDescription
    });
    // #endregion
  }
  /*........................................ ................................*/
  setMin_MaxDrawDateTime() {
    let tempMinDrawDateTime = new Date();
    let tempMaxDrawDateTime = new Date();
    // JIRA-157/117- Consider first print label date instead of latest print label date
    //For home modality, min date is always first print label date
    if (this.ENUM_WORKFLOW.HOME == this.workFlow) {
      tempMinDrawDateTime = new Date(this.firstPrintLabelDateResponse[0].FirstPrintLabelDate)
      if (this.shipmentReceivedDateLocalFormat) {
        tempMaxDrawDateTime = this.shipmentReceivedDateLocalFormat
      }
    }
    else {
      //Chroneic/Accute modality doesn't have any restriction on min date selection. Its controlled by validatins while saving
      tempMinDrawDateTime = null;
    }
    this.min = tempMinDrawDateTime
    this.max = tempMaxDrawDateTime
    /*----------------Time -----------------------------*/
  }

  setDefaultDrawDateTime() {
    let maxPrintLabelDate = this.manifestData.reduce(function (a, b) {
      return new Date(a.PrintLabelDate) > new Date(b.PrintLabelDate) ? a : b;
    });
    this.drawDate = new Date(maxPrintLabelDate.PrintLabelDate);
    let actiualDrawDate = maxPrintLabelDate.PrintLabelDate.toString().split(" ");
    let drawTime = actiualDrawDate[1].split(":")
    this.selectedHour = drawTime[0];
    this.selectedMinutes = drawTime[1];
  }
  getShipmentReceivedDate(fnCallBack) {
    if (this.ENUM_WORKFLOW.HOME == this.workFlow && !this.shipmentReceivedDateLocalFormat) {
      let requisitionID = this.manifestData[0].LabRequisitionID
      let param =
      {
        GETSHIPMENTRECEIVEDDATE:
        {
          LabRequisitionID: requisitionID,
        }
      }
      this._requisitionService.getShipmentReceivedDate(param).subscribe(response => {
        if (response && response[0].ShipmentReceivedDate) {
          this.shipmentReceivedDateLocalFormat = new Date(this.customDatePipe.transform(response[0].ShipmentReceivedDate, "local", "MM/dd/yyyy HH:mm"));
        }
        fnCallBack();
      },
        (error) => {
          fnCallBack();
        });
    }
    else {
      fnCallBack();
    }
  }

}